import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=2372bfac&scoped=true&"
import script from "./Prescription.vue?vue&type=script&lang=js&"
export * from "./Prescription.vue?vue&type=script&lang=js&"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=2372bfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372bfac",
  null
  
)

export default component.exports